/** @format */

import React, { useState } from "react";

function GenerateCollapsibleCategories({ obj, i }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="position-relative t-1">
      <ul className="p-0 my-0">
        <li style={{ listStyle: "none" }}>{obj.ans[0]}</li>
        {expanded && (
          <span>
            {obj.ans.slice(1).map((category, idx) => {
              return <li key={idx}>{category}</li>;
            })}
          </span>
        )}
      </ul>
      <p>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setExpanded(!expanded);
          }}
        >
          {expanded ? "Show Less" : "Show More"}
        </a>
      </p>
    </div>
  );
}

export default GenerateCollapsibleCategories;
